import { useState, useEffect } from "react";
import "../styles/pos.css";

const Settings = () => {
  const [printerType, setPrinterType] = useState("THERMAL");

  useEffect(() => {
    const saved = localStorage.getItem("printerType");
    if (saved) setPrinterType(saved);
  }, []);

  const save = () => {
    localStorage.setItem("printerType", printerType);
    alert("Printer setting saved");
  };

  return (
    <div className="page-container">
      {/* ===== HEADER ===== */}
      <div className="page-header">
        <h2>Settings</h2>
      </div>

      {/* ===== PRINTER SETTINGS ===== */}
      <div className="card">
        <h4>Printer Settings</h4>

        <div className="settings-row">
          <label>Invoice Printer Type</label>

          <select
            value={printerType}
            onChange={e => setPrinterType(e.target.value)}
          >
            <option value="THERMAL">Thermal (80mm)</option>
            <option value="A4">A4 GST Invoice</option>
          </select>
        </div>

        <button className="primary-btn" onClick={save}>
          Save Settings
        </button>
      </div>
    </div>
  );
};

export default Settings;
